import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { UTILS } from "utils";
import { useMenuContext } from "store/contexts/Menus";
import { useDispatch, useSelector } from "react-redux";
import { LoaderAction } from "redux/actions";
import { useParams } from "react-router-dom";
import { logToSentry } from "utils/Utils";
import { API } from "api";
import { errorHandler } from "api/api/errorHandler";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";

const DeleteCategory = ({ open, handleValues, onClose, cat, index }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();

  const { isLoading } = useSelector((state) => state.LoaderReducer);

  const { menuState, updateState } = useMenuContext();

  const deleteCategory = async () => {
    try {
      if (!cat?.categoryId?._id) {
        logToSentry(
          `deleteCategory issue ${JSON.stringify(menuState)}`,
          "error"
        );
        window.location.reload();
        UTILS.errorNotification("Please try again later");
        return;
      }
      dispatch(LoaderAction.setLoading(true));
      const result = await API.unLinkCategoryWithMenu({
        brandId: UTILS.getCurrentUser()?.brandId,
        menuId: params?.menuId || menuState.menuId,
        categoryId: cat?.categoryId?._id,
      });

      if (result?.success === 1) {
        handleValues(index);
        updateState("indexToUpdateDelete", index);
        UTILS.successNotification(result?.data?.message || "Category unlinked");
        onClose();
      } else {
        UTILS.errorNotification(errorHandler(result?.message));
      }
    } catch (error) {
      UTILS.errorNotification(errorHandler(error?.error?.message));
    } finally {
      dispatch(LoaderAction.setLoading(false));
    }
  };

  const deleteFooter = (
    <div className="mx-auto flex w-full max-w-[760px] items-center justify-center gap-4 pb-2">
      <AppButton
        variant="secondary"
        size="lg"
        className="w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
        disabled={isLoading}
        onClick={onClose}
      >
        {t("No, Keep It")}
      </AppButton>
      <AppButton
        variant="primary"
        size="lg"
        className="w-1/2 text-4xl"
        loading={isLoading}
        disabled={isLoading}
        onClick={deleteCategory}
      >
        {t("Yes, Delete")}
      </AppButton>
    </div>
  );

  const categoryName = cat?.categoryId?.baseLanguage?.name;

  return (
    <AppModal
      open={open}
      onClose={onClose}
      width={550}
      closable={false}
      footer={deleteFooter}
    >
      <div className="flex flex-col items-center px-8 text-center">
        <div className="mb-6 mt-6 h-44 w-44">
          <AppIcon name="trashRed" size={170} className="h-full w-full" />
        </div>
        <h1 className="text-24px font-semibold text-gray-900">
          {t("Delete Category")}
        </h1>
        <p className="mb-0 text-3xl text-gray-500">
          {categoryName
            ? t("Are you sure you want to delete {{name}}?", {
                name: categoryName,
              })
            : t("Are you sure you want to delete this Category")}
        </p>
      </div>
    </AppModal>
  );
};

DeleteCategory.propTypes = {
  open: PropTypes.bool,
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
  cat: PropTypes.object,
  index: PropTypes.number,
};
export default DeleteCategory;
